export const discordLink = "https://discord.gg/GXXcRmuqAT";
export const githubLink = "https://github.com/LlONED/RONF-maps";
